import { RangeFacetCountsDTO, MappedRangeFacetItem } from "./filters.type";
import { mapRangeFacetCounts } from "./mapRangeFacetCounts";
import getEnvironment from "../getEnvironment";

const getRangeFacetCounts = async (
  url: string,
  currentFacet: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<MappedRangeFacetItem[]> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while fetching the data.`
    );
  }

  const result: RangeFacetCountsDTO = await res.json();
  return mapRangeFacetCounts(result);
};

export default getRangeFacetCounts;
